import {useEffect, useRef} from 'react';

export const useAutoScrollToTop = <T extends HTMLElement>(
    dependency: unknown[]
) => {
    const containerRef = useRef<T>(null);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        containerRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }, [...dependency]);

    return {
        containerRef,
    };
};
